import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3)
}));

const DescriptionContent = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& p': {
    marginBottom: theme.spacing(2),
  }
}));

const LearningPathDescription = ({ lpath }) => {
  return (
    <SectionPaper elevation={0}>
      <Typography variant="h5" component="h2" gutterBottom>
        About This Learning Path
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      <DescriptionContent 
        dangerouslySetInnerHTML={{ __html: lpath.description || 'No description available.' }} 
      />
    </SectionPaper>
  );
};

export default LearningPathDescription;